/* global window, $, setTimeout, clearTimeout */
// eslint-disable-next-line angular/factory-name
angular.
module("lightbox").
factory("lightbox", function lightboxFactory() {
	"use strict";

	var escKey = 27;
	var lightboxPadding = 20;

	var image = "<img />";
	var template = "<div class=\"lightbox\"><a href=\"\"><img src=\"./img/close-button.png\"></a></div>";
	var loader = "<img src=\"./img/ajax-loader.gif\" class=\"loading\" />";

	var defaultOptions = {duration: 300};

	var $currentLightbox = null;

	var groups = {};

	function getWindowWidth() {
		return $(window).width();
	}

	function getWindowHeight() {
		return $(window).height();
	}

	function getScrolltop() {
		return $(window).scrollTop();
	}

	function uniqueId() {
		return Math.floor(Math.random() * 100000000) + 1;
	}

	function reposition($lightbox) {
		var width = $lightbox.innerWidth();
		var height = $lightbox.innerHeight();
		$lightbox.stop().animate({
			left: getWindowWidth() / 2 - width / 2,
			top: getWindowHeight() / 2 - height / 2,
		}, 100, "swing");
	}

	// eslint-disable-next-line no-unused-vars
	function resize($lightbox) {
		var $image = $lightbox.find("> img");
		var width = $image.innerWidth();
		var height = $image.innerHeight();

		$lightbox.animate({
			width: width,
			height: height,
		}, 400, "swing");
	}

	function bindEvents($lightbox) {
		$lightbox.find("a").on("click", function onClick(e) {
			e.preventDefault();
			close();
		});
	}

	function unbindEvents($lightbox) {
		return $lightbox.find("a").off("click");
	}

	function preloadImage(url, cb) {
		var $image = $(image);
		$image.attr("src", url);
		$image.on("load", cb);

		$image.css({
			position: "absolute",
			left: "-999999em",
			top: "-999999em",
		});
		$image.appendTo($("body"));

		return $image;
	}

	function containImageSize(imgWidth, imgHeight) {
		var winWidth = getWindowWidth() - lightboxPadding * 4;
		var winHeight = getWindowHeight() - lightboxPadding * 4;

		var newImgWidth = imgWidth;
		var newImgHeight = imgHeight;

		if (newImgWidth > winWidth) {
			newImgWidth = winWidth;
			newImgHeight = imgHeight * (newImgWidth / imgWidth);
		}

		if (newImgHeight > winHeight) {
			newImgHeight = winHeight;
			newImgWidth = imgWidth * (newImgHeight / imgHeight);
		}

		return {width: newImgWidth, height: newImgHeight};
	}

	function create(url, cb) {
		var $lightbox = $(template);
		var $image = preloadImage(url, function callback() {
			var imageSize = containImageSize($image.innerWidth(), $image.innerHeight());

			$image.removeAttr("style");

			$image.css({
				width: 0,
				height: 0,
			});

			$lightbox.append($image);

			$image.animate({width: imageSize.width}, 400, "swing");
			$image.animate({height: imageSize.height}, 400, "swing");

			$lightbox.animate({
				width: imageSize.width,
				left: getWindowWidth() / 2 - imageSize.width / 2 - lightboxPadding,
			}, 400, "swing");

			$lightbox.animate({
				height: imageSize.height,
				top: getWindowHeight() / 2 - imageSize.height / 2 - lightboxPadding + getScrolltop(),
			}, 400, "swing");

			cb();
		});

		return $lightbox;
	}

	function show(url, o) {
		// eslint-disable-next-line no-param-reassign
		o = o || {};
		close(o);

		var $loader = $(loader);
		var $lightbox = create(url, function callback() {
			$lightbox.find("a").fadeIn();
			return $loader.remove();
		});

		$lightbox.append($loader);
		$lightbox.css({
			left: getWindowWidth() / 2 - 31 / 2 - lightboxPadding,
			top: getWindowHeight() / 2 - 31 / 2 - lightboxPadding + getScrolltop(),
		});

		bindEvents($lightbox);

		$lightbox.appendTo($("body"));
		$currentLightbox = $lightbox;

		// Return void because of http://docs.angularjs.org/error/$parse/isecdom
	}

	function close(o) {
		// eslint-disable-next-line no-param-reassign
		o = o || {};
		if (!$currentLightbox) {
			return;
		}
		var $cLightBox = $currentLightbox;
		$currentLightbox = null;
		var options = angular.extend(o, defaultOptions);
		$cLightBox.fadeOut(options.duration, function callback() {
			unbindEvents($cLightBox);
			$cLightBox.remove();
		});

		// Return void because of http://docs.angularjs.org/error/$parse/isecdom
	}

	function setup() {
		$("body").on("keyup", function onKeyup(e) {
			if (e.which === escKey) {
				close();
			}
		});

		$("body").on("mouseup", function onMouseup(e) {
			var $target = $(e.target).closest(".lightbox");
			if ($target.is($currentLightbox)) {
				return;
			}

			close();
		});

		var resizeTimeoutId = 0;
		$(window).on("resize", function onResize() {
			if ($currentLightbox === null) {
				return;
			}
			clearTimeout(resizeTimeoutId);
			// eslint-disable-next-line angular/timeout-service
			resizeTimeoutId = setTimeout(function onTimeout() {
				reposition($currentLightbox);
			}, 50);
		});
	}

	function hasOpenLightbox() {
		return $currentLightbox !== null;
	}


	// eslint-disable-next-line no-unused-vars
	function addToGroup(name, url) {
		groups[name] = groups[name] || [];
		groups[name].push({
			id: uniqueId(),
			url: url,
			parent: name,
		});
	}

	return {
		show: show,
		close: close,
		setup: setup,
		hasOpenLightbox: hasOpenLightbox,
	};
});
